export default {
    title: `My social analytics`,
    legend: `Average per post calculated over the last month`,
    link: `Access analytics`,
};
